module.exports = "<md-button\n  ng-class=\"{'md-icon-button': !$ctrl.title}\"\n  ng-click=\"$ctrl.openDialog()\"\n  aria-label=\"Add new item\"\n  data-test-id=\"add-item\"\n>\n  <span ng-if=\"$ctrl.title\" class=\"mr-2\" ng-bind=\"$ctrl.title\"></span>\n  <md-icon>add_circle</md-icon>\n</md-button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/addItem/addItem.html
// module id = 861
// module chunks = 0